/*
 * Copyright (C) 2018 - present by Potentially
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../../shared/store';

export interface GoogleCalendarAuthUrlResponse {
  authUrl: string;
}

export interface GoogleCalendarStatusResponse {
  connected: boolean;
}

export interface GoogleCalendarDisconnectResponse {
  success: boolean;
  message: string;
}

export interface GoogleCalendarBulkSyncResponse {
  success: boolean;
  message: string;
}

export interface GoogleCalendarSyncEventResponse {
  success: boolean;
  message: string;
}

export const GOOGLE_CALENDAR_DATA_SERVICE = new InjectionToken<GoogleCalendarDataService>('[GoogleCalendar] DataService');

export interface GoogleCalendarDataService {
  getAuthUrl(): ObservableResult<GoogleCalendarAuthUrlResponse>;

  getStatus(): ObservableResult<GoogleCalendarStatusResponse>;

  disconnect(): ObservableResult<GoogleCalendarDisconnectResponse>;

  syncAll(): ObservableResult<GoogleCalendarBulkSyncResponse>;

  syncEvent(eventId: string): ObservableResult<GoogleCalendarSyncEventResponse>;
}
